import { BackupPolicyType } from '@repo/api-gw-sdk';

export const isPitrPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR
  );
};

export const isStandardPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_NATIVE_STANDARD
  );
};

export const isNativePolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_NATIVE_STANDARD ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR
  );
};

export const isContinuousPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR
  );
};
